<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                            </span>
                            <span v-else-if="tableValye.entityField == 'createTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>

                            <el-tag v-else-if="tableValye.entityField == 'state'" size="mini" type="primary">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                {{ $common.getIsGsp(tableValye.formatterContent,
                                scope.row[tableValye.entityField])
                            }}
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <el-dialog :title="'已上传' + upType" :visible.sync="diaContract" width="800px">
            <upDataFile v-if="diaContract" :upDataUrl="'bgStockuploadStockFile'" ref="upFile"></upDataFile>
            <div class="fileTable">
                <el-button class="btn" type="primary" size="mini" @click="batchDownLoad">批量下载</el-button>
                <el-table size="mini" :data="fileData" border style="width: 100%">
                    <el-table-column prop="codingNum" show-overflow-tooltip label="编码">
                    </el-table-column>
                    <el-table-column prop="busType" show-overflow-tooltip label="业务类型">
                    </el-table-column>
                    <el-table-column prop="createrName" show-overflow-tooltip label="上传人">
                    </el-table-column>
                    <el-table-column prop="createTime" show-overflow-tooltip label="上传时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">
                                {{ $common.getLocalTime(scope.row.createTime) }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fileName" show-overflow-tooltip label="文件名">
                    </el-table-column>
                    <el-table-column prop="type" show-overflow-tooltip label="文件类型">
                    </el-table-column>
                    <el-table-column prop="fileUrl" show-overflow-tooltip label="附件">
                        <template slot-scope="scope">
                            <ul v-if="scope.row.fileUrl">
                                <li style="display: flex;align-items: center;flex-wrap: wrap; width: 31px;height: 31px;margin-right: 5px;" v-for="(item, index) in scope.row.fileUrl.split(',')" :key="index">
                                    <cusImage style="width: 30px;height: 30px;" :src="$common.getFileAddress(item)" :preview-src-list="$common.getFileAddressARR(scope.row.fileUrl.split(','))">
                                    </cusImage>
                                </li>
                            </ul>
                        </template>
                    </el-table-column>
                    <el-table-column width="160" label="操作">
                        <template slot-scope="scope">
                            <div class="imgs">
                                <el-link @click="downLoadFile(scope.row.fileUrl)" type="primary" :underline="false" style="margin-left:10px">另存为</el-link>
                                <!-- <el-link @click="openFile(scope.row.codingNum,scope.row.fileId,scope.row,1)" type="success" :underline="false" style="margin-left:10px">修改</el-link> -->
                                <el-link @click="delFile(scope.row.fileId)" type="danger" :underline="false" style="margin-left:10px">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import creditApplyAction from '@/components/creditApplyAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        creditApplyAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            multipleSelection: [],
            showStatus: false,
            actionData: {},

            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},
            //-----------------------
            upType: "",//上传名称
            diaContract: false,
            fileData: [],
            fileIds: [],
            busynessKey: [],
            requesUrl: "",
            imgUrl: "",

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 通过明细id查询文件列表
        async getFileListByIds(flag) {
            this.fileIds = []
            this.busynessKey = []
            this.multipleSelection.forEach(item => {
                this.fileIds.push(item.bgsId)
                this.busynessKey.push(item.bgmId)
            })
            let params = {
                busynessId: this.fileIds.toString(),
                fileType: this.upType
            }
            let responseData = await this.$http.queryFileListByIds(params);
            if (responseData.status == 200) {
                this.fileData = responseData.result.list
                if (flag) {
                    this.fileData.forEach(item => {
                        const src = this.imgUrl + '/' + item.fileUrl
                        const img = new Image();
                        img.src = src
                        img.onload = () => {
                            if (img.width > img.height) {
                                item.flag = true
                            } else {
                                item.flag = false
                            }
                        };
                    })
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            if (flag) {
                this.diaContractSee = true
            } else {
                this.diaContract = true
            }
        },
        //   下载文件
        downLoadFile(e) {
            window.location.href = this.requesUrl + '/psaccount/downDetailFile?url=' + e
        },
        //批量下载
        async batchDownLoad() {
            const url = `${this.requesUrl}/psaccount/downFileZip?busynessId=${encodeURIComponent(this.fileIds.toString())}&busynessType=${encodeURIComponent(this.upType)}`
            const form = document.createElement('form')
            form.method = 'POST'
            form.action = url
            form.style.display = 'none'
            document.body.appendChild(form)
            form.submit()
            document.body.removeChild(form)
        },
        //   删除文件
        async delFile(e, type) {
            if (type) {
                let params = {
                    ids: [e]
                }
                let responseData = await this.$http.delFile(params);
                if (responseData.status == 200) {
                    this.getFileListByIds()
                    this.$refs.upFile.fileList = []
                    this.$refs.upFile.codingNum = ""
                }
                return
            }
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                let params = {
                    ids: [e]
                }
                let responseData = await this.$http.delFile(params);
                if (responseData.status == 200) {
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    });
                    this.$refs.upFile.fileList = []
                    this.$refs.upFile.codingNum = ""
                    this.getFileListByIds()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }).catch(() => { });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },

        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.getButtonList();
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.formDataList = this.pageShowData.jurFormVoList
                this.pageShowData.jurHead && this.pageShowData.jurHead.jurconfigform.forEach((item) => {
                    item.setField && this.initParamValue(item.setField)
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 1:
                    if (this.multipleSelection.length == 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.upType = '检验报告'
                    this.getFileListByIds()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.bgStockqueryStockPage(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()

        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgurl()
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>